package pl.mothdigital.neuronowi.theme

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.silk.theme.colors.ColorPalette

object NeuroNowiGreen : ColorPalette {
    override val _50: Color.Rgb
        get() = Color.rgb(0xeff8e9)
    override val _100: Color.Rgb
        get() = Color.rgb(0xd7efc6)
    override val _200: Color.Rgb
        get() = Color.rgb(0xbce5a0)
    override val _300: Color.Rgb
        get() = Color.rgb(0xa1db79)
    override val _400: Color.Rgb
        get() = Color.rgb(0x8dd55b)
    override val _500: Color.Rgb
        get() = Color.rgb(0x78c043)
    override val _600: Color.Rgb
        get() = Color.rgb(0x6ab03c)
    override val _700: Color.Rgb
        get() = Color.rgb(0x589d32)
    override val _800: Color.Rgb
        get() = Color.rgb(0x478a29)
    override val _900: Color.Rgb
        get() = Color.rgb(0x266415)
}
